import { useEffect, useState } from 'react';
import apiService from '../../axios/apiService';

export const useDashboard = () => {
  const [data, setData] = useState();
  const getList = async () => {
    // Fetch clinics list
    const list = await apiService.getDashboard();
    list && setData(list); // update data state
    return list;
  };

  // Initial Render
  useEffect(() => {
    getList();
  }, []);

  return {
    data,
    getList,
  };
};
